export const fastGamePlayTextContent = {
  backBtnText: <span className="text">Back to Games</span>,
  fullscreenBtnText: <span className="text">Full Screen</span>,
  imgSrcGame: "/assets/stock-img/fast_game_play_img.webp",
  paragraphText: (
    <>
      Shadow of sabbah <br />
      Unearth hidden treasures in Mining Rush. <br />
      Set deep underground, the 7×7 grid offers a host of lavish symbols, with
      five or more landing in a cluster awarding impressive wins. <br />
      Any winning combination featuring a dynamite-themed Scatter in the base
      game sees the Scatter turn into a mine, which remains stuck on the reels
      for the remainder of the round, strengthening the chance of hitting
      additional wins. <br />
      Mines accumulate progressive points, receiving one point for each win
      generated. When three points are collected the mines progress to the next
      level, guaranteeing further winnings. <br />
    </>
  ),
  listItemTitle: "What to expect:",
  listText: [
    {
      listItem:
        "Landing three or more Scatters triggers the free spins round, awarding a maximum of 20 spins.",
    },
    {
      listItem:
        "During the free spins, mines from the base game keep their level and progress points when the free spins bonus is launched.",
    },
    {
      listItem:
        "For every new mine created in free spins, a further two spins are awarded.",
    },
  ],
  headingText: "More Games",
};
